import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { DynamicScriptLoaderServiceService } from '../../_services/dynamic-script-loader-service.service';
import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';
import {PatientsService } from "../../_services/patients.service";
import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-patientsearch',
  templateUrl: './patientsearch.component.html',
  styleUrls: ['./patientsearch.component.css']
})
export class PatientsearchComponent implements OnInit {


  userdetaild: string;
  baseUrl: string = environment.baseUrl;

  id: string;
  returnUrl: string;
  appointments: any[] = [];
  total: any[] = [];

  // tslint:disable-next-line:max-line-length
  constructor(private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private doctorservice: DoctorService, private patientsservice: PatientsService ,private toaster: ToasterService) { }

  ngOnInit() {
    // DynamicScriptLoaderServiceService.adminScripts();
    // DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/custom.js');
    this.userdetaild = this.authenicationService.userDetails();

    this.id = this.userdetaild['_id'];


    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }

    const payload = {
      docid: this.id
    };
    // console.log(payload);
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';



    this.getDoctorAppointment(payload);

  }

  getDoctorAppointment(docid) {
    this.doctorservice.getDoctorAppointment(docid)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Appointments', data.ResponseMessage);
            let appoint = data.DoctorAppointment;
            for(let i = 0; i < appoint.length; i++){
              if(this.appointments.some(person => person.patientid === appoint[i]['clientid']['_id'])){
                continue;
              }

              var total = this.getPatientTotalAppointment(appoint[i]['clientid']['_id']);
              console.log(total);
              const list = {
                _id: appoint[i]['_id'],
                scheduleId: appoint[i]['scheduleId'],
                docid: appoint[i]['docid'],
                clientid: appoint[i]['clientid'],
                patientid: appoint[i]['clientid']['_id'],
                appointmentMode: appoint[i]['appointmentMode'],
                total_session: appoint.length,
                overall_session: total
              };
              this.appointments.push(list);
            }

            console.log(this.appointments);
            // console.log(this.appointments);
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('Appointments', data.ResponseMessage);
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Doctor', error.error.ResponseMessage);
          setTimeout(()=>{
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  getPatientTotalAppointment(cid){
    const id = {
      clientid: cid
    };

    this.patientsservice.getPatientAppointment(id)
      .subscribe(
        (data: any) => {

          this.total.push(data.ClientAppointment.length);

        }
      );
    return this.total;
  }
}
